import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";

export default function Auth() {
  const { login, register, formatError } = useAuth();
  const nav = useNavigate();
  const [mode, setMode] = useState("login");
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setErr(""); setLoading(true);
    try {
      if (mode === "login") { await login(form.email, form.password); }
      else { await register(form.name, form.email, form.password); }
      toast.success("Welcome to GULIT");
      nav("/account");
    } catch (e) { setErr(formatError(e.response?.data?.detail) || e.message); }
    finally { setLoading(false); }
  };

  return (
    <div className="mx-auto max-w-md px-6 py-20">
      <h1 className="font-display text-4xl text-center" data-testid="auth-title">{mode === "login" ? "Welcome Back" : "Create Account"}</h1>
      <p className="text-center text-muted-foreground mt-2">{mode === "login" ? "Sign in to your GULIT account" : "Join the GULIT marketplace"}</p>
      <form onSubmit={submit} className="mt-10 space-y-4">
        {mode === "register" && <Input required placeholder="Full name" value={form.name} onChange={(e) => setForm({...form, name: e.target.value})} className="rounded-none h-12" data-testid="auth-name" />}
        <Input required type="email" placeholder="Email" value={form.email} onChange={(e) => setForm({...form, email: e.target.value})} className="rounded-none h-12" data-testid="auth-email" />
        <Input required type="password" placeholder="Password" value={form.password} onChange={(e) => setForm({...form, password: e.target.value})} className="rounded-none h-12" data-testid="auth-password" />
        {err && <p className="text-sm text-destructive" data-testid="auth-error">{err}</p>}
        <Button disabled={loading} className="w-full rounded-none h-12 bg-[#D4AF37] text-black font-semibold hover:brightness-110" data-testid="auth-submit">{loading ? "Please wait…" : mode === "login" ? "Sign In" : "Create Account"}</Button>
      </form>
      <p className="text-center text-sm text-muted-foreground mt-6">
        {mode === "login" ? "New to GULIT? " : "Already have an account? "}
        <button onClick={() => { setMode(mode === "login" ? "register" : "login"); setErr(""); }} className="text-[#D4AF37] underline" data-testid="auth-switch">{mode === "login" ? "Create account" : "Sign in"}</button>
      </p>
      <p className="text-center text-xs text-muted-foreground mt-4">Demo: customer@gulit.com / Customer2026!</p>
    </div>
  );
}
